import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { breadcrumbContext } from '../../utils/useBreadcrumbs';
import './Breadcrumbs.scss';

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  
  // Get current path and split it into segments
  const pathnames = location.pathname.split('/').filter(x => x);
  
  // Create breadcrumb mapping for readable names
  const breadcrumbNameMap: { [key: string]: string } = {
    'about': 'About Us',
    'events': 'Events',
    'projects': 'Projects',
    'donate': 'Donate',
    'resources': 'Resources',
    'gallery': 'Gallery',
    'get-involved': 'Get Involved',
    'contact': 'Contact',
    'privacy-policy': 'Privacy Policy',
    'privacy': 'Privacy Policy',
    'terms': 'Terms of Service',
    'cookies': 'Cookies Policy',
  };

  // Hide breadcrumbs on home page
  if (location.pathname === '/') {
    return null;
  }

  // Generate structured data for SEO
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [
      {
        '@type': 'ListItem',
        'position': 1,
        'name': 'Home',
        'item': window.location.origin
      },
      ...pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const customContext = breadcrumbContext[routeTo];
        const displayName = customContext?.customTitle || breadcrumbNameMap[name] || name;
        
        return {
          '@type': 'ListItem',
          'position': index + 2, // +2 because Home is position 1
          'name': displayName,
          'item': `${window.location.origin}${routeTo}`
        };
      })
    ]
  };

  return (
    <div className="breadcrumbs-container">
      <div className="breadcrumbs">
        <Link to="/">Home</Link>
        {pathnames.map((name, index) => {
          // Build the path up to this point
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          
          // Check if there's a custom title for this path
          const customContext = breadcrumbContext[routeTo];
          const displayName = customContext?.customTitle || breadcrumbNameMap[name] || name;
          
          return (
            <React.Fragment key={name}>
              <span className="separator">/</span>
              {isLast ? (
                <span className="current">{displayName}</span>
              ) : (
                <Link to={routeTo}>{displayName}</Link>
              )}
            </React.Fragment>
          );
        })}
      </div>
      
      {/* Add structured data for SEO */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </div>
  );
};

export default Breadcrumbs; 